import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DataStreamService } from '@portal-core/data-stream/services/data-stream.service';
import { NotificationPage } from '@portal-core/notifications/models/notification-page.model';
import { Notification } from '@portal-core/notifications/models/notification.model';
import { NotificationsService } from '@portal-core/notifications/services/notifications.service';
import { NotificationList } from '@portal-core/notifications/util/notification-list';
import { filter } from 'lodash';
import { Observable } from 'rxjs';

@Component({
  selector: 'mc-team-notification-list',
  templateUrl: './team-notification-list.component.html',
  styleUrls: ['./team-notification-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamNotificationListComponent extends NotificationList implements OnChanges {
  @HostBinding('class.mc-notification-list') notificationListClass = true;
  @Input() teamId: number;

  constructor(protected notificationsService: NotificationsService, protected dataStreamService: DataStreamService, cdr: ChangeDetectorRef) {
    super(notificationsService, dataStreamService, cdr);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.teamId) {
      this.onConfigurationChanged();
    }
  }

  protected isConfigured(): boolean {
    return typeof this.teamId === 'number';
  }

  protected fetchNotifications$(pageSize: number, pageIndex: number): Observable<NotificationPage> {
    return this.notificationsService.getNotificationsByTeamId$(this.teamId, pageSize, pageIndex);
  }

  protected filterNotifications(notifications: { [id: string]: Notification }): Notification[] {
    return filter(notifications, (notification: Notification) => notification.TeamId === this.teamId);
  }
}
